import { ContractType } from '@/types/commercial/contracts';

export interface ContractSummaryFieldSchema {
  key: string;
  label: string;
  description?: string[];
  inputType?: 'text' | 'number';
}

export interface ContractSummarySchema {
  fields: ContractSummaryFieldSchema[];
}

const SIM_CARD_SUMMARY_SCHEMA: ContractSummarySchema = {
  fields: [
    {
      key: 'equipmentConfigurationValue',
      label: 'Valor de configuração de equipamentos (quando aplicável)',
    },
    { key: 'totalManagedLines', label: 'Quantidade total de linhas geridas', inputType: 'number' },
    { key: 'loyaltyPerLine', label: 'Fidelidade por linha' },
    {
      key: 'activationGracePeriod',
      label: 'Carência para ativação',
      description: [
        'a. A linha será ativada após o uso de mais de 100 Quilobytes de dados ou automaticamente após o período informado.',
        'b. Após a ativação, será iniciada a fidelidade das linhas.',
      ],
    },
    { key: 'lineCancellation', label: 'Cancelamento de linhas' },
    { key: 'lineReplacement', label: 'Substituição de linha' },
    {
      key: 'exceededMbValue',
      label: 'Valor do Megabyte excedente ao plano contratado',
      description: [
        'a. Quando houver compartilhamento de dados, considerar o excedente ao montante contratado.',
        'b. Planos sem compartilhamento calculam o excedente por linha.',
        'c. Os planos compartilhados podem ser limitados em até duas vezes o montante do plano individual contratado.',
      ],
    },
    { key: 'smsMo', label: 'Uso de SMS para envio pelo equipamento (MO)' },
    { key: 'smsMt', label: 'Uso de SMS recepção (MT)' },
  ],
};

export const CONTRACT_SUMMARY_SCHEMAS: Partial<Record<ContractType, ContractSummarySchema>> = {
  [ContractType.SIM_CARD]: SIM_CARD_SUMMARY_SCHEMA,
};

export function createContractSummaryValue(
  schema: ContractSummarySchema | undefined,
  currentValue: Record<string, unknown> = {},
): Record<string, unknown> {
  if (!schema) return currentValue;

  return schema.fields.reduce<Record<string, unknown>>(
    (value, field) => ({
      ...value,
      [field.key]: value[field.key] ?? (field.inputType === 'number' ? 0 : ''),
    }),
    currentValue,
  );
}
